<div class="top-bar">
  <div class="content">
    <span (click)="goBack()">
      <img class="h-18" src="assets/images/icon/chevronleft.svg" />
      {{ translations['back'] }}
    </span>
    <span class="verticle-line"> </span>
    <span (click)="navigateToLadingPage()">
      <img src="assets/images/icon/refresh.svg" />
      {{ translations['restart'] }}
    </span>
  </div>
  <select
    [value]="currentLanguage"
    (change)="languageChange($event)"
    class="select-dropdown"
  >
    <option
      *ngFor="let option of languageOptions"
      [value]="option?.value"
      [selected]="option.value === currentLanguage"
    >
      {{ option.value }}
    </option>
  </select>
</div>
